import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { organizationAdminsApi } from '../../api/lib/organization-admins';
import { organizationAdminsKeys } from '../../api/query-keys/organization-admins';

import { ApiError } from '@/types/interfaces/api-error';

export const useInviteAdmin = (onSuccess?: () => void) => {
  const { t } = useTranslation(['organizationAdmins']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      email,
      isOwner,
      friendlyName,
    }: {
      email: string;
      isOwner: boolean;
      friendlyName: string;
    }) => organizationAdminsApi.inviteNewOrganizationAdmin(email, isOwner, friendlyName),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: organizationAdminsKeys.lists() });
      toast.success(t('organizationAdmins:inviteSuccess'));
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
